import { LOCALE_DEFAULT } from '@model/const/locales.ts';

export default {
    computed: {
        phoneInputSettings() {
            return this.$store.state.slices.items?.['s-list-form-elements']?.phoneInput || null;
        },
    },
    methods: {
        onPhoneInputChange(event) {
            const field = ('phone_number' in this.form) ? 'phone_number' : 'phone';
            this.form[field] = event.number;
            this.form.phoneCountryCode = event.country;
        },
    },
    async serverPrefetch() {
        const locale = this.$store.state.geolocation.finalLocale || LOCALE_DEFAULT;
        await this.$store.dispatch('slices/getSyncedData', { slice: 's-list-form-elements', locale });
    },
};
